"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children", "style"];
var Cell = function Cell(_ref) {
  var children = _ref.children,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("td", (0, _extends2["default"])({
    style: style
  }, props), children);
};
Cell.defaultProps = {
  children: {},
  style: {}
};
Cell.propTypes = {
  children: _propTypes["default"].node,
  style: _propTypes["default"].shape({})
};
var _default = exports["default"] = Cell;